// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wg6o","content":"styles_content__zrXuB"};